import React, { useContext } from 'react';
import type { ClipboardHooks } from './Clipboard';

export const ClipboardHooksContext = React.createContext<ClipboardHooks | null>(
  null,
);

export const useClipboardHooks = () => useContext(ClipboardHooksContext);
